/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqDto } from '../../models/faq-dto';

export interface FaqControllerTogglePinnedV1$Params {
  id: string;
}

export function faqControllerTogglePinnedV1(http: HttpClient, rootUrl: string, params: FaqControllerTogglePinnedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerTogglePinnedV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqDto>;
    })
  );
}

faqControllerTogglePinnedV1.PATH = '/api/v1/faq/{id}/pin';
